import { Globe, type LucideIcon, PenLine, Sparkles, Wand2 } from 'lucide-react';

import type { Translate } from '@shared/hooks/locale';

type BuyerLeadSourceMeta = {
  label: string;
  Icon: LucideIcon;
};

// Known buyer-lead sources. Anything else (portal names like "homegate",
// "immoscout24", …) falls back to a humanized label + a generic globe icon.
export const getBuyerLeadSourceMeta = (
  source: string | null | undefined,
  t: Translate,
): BuyerLeadSourceMeta => {
  switch (source) {
    case 'manual':
      return { label: t('Manual'), Icon: PenLine };
    case 'matching':
      return { label: t('Matching'), Icon: Sparkles };
    case 'auto-matching':
      return { label: t('Auto-matching'), Icon: Wand2 };
    case null:
    case undefined:
    case '':
      return { label: t('Unknown source'), Icon: Globe };
    default: {
      const humanized = source
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
      return { label: humanized, Icon: Globe };
    }
  }
};

export const isMatchingSource = (source: string | null | undefined): boolean =>
  source === 'matching' || source === 'auto-matching';
